import React from 'react';
import { FormGroup } from 'arag-ui-lib';
import { FORM_GROUP_VARIANTS } from '../../helpers/formGroupVariants';
import { checkIfQuestionsHasBeenModified } from '../../helpers/questions/functions';
import { OPPONENT_NAME_MN } from '../../helpers/constants';

const OpponentChildQuestion = (props) => {
    const {
        oppQuestion,
        opponent,
        opponentHandler,
        opponentIndex,
        isPlain,
        isLabelClickable,
        openHistoryModal,
        application,
        getInputName,
        getOptions,
        isApplicationTab
    } = props;

    // Helper to check if a specific question has been modified
    const checkIsLabelClickable = (machineName) => {
        return checkIfQuestionsHasBeenModified(
            opponent.id,
            application,
            OPPONENT_NAME_MN,
            machineName
        ) && isApplicationTab;
    };

    const name = getInputName(oppQuestion.machineName);
    const options = getOptions(oppQuestion, opponent[name]);
    const selectedOption = options.find( o => o.key && opponent[name] && o.key.toString() === opponent[name].toString() );
    const label = isPlain && selectedOption ? selectedOption.label : '';
    const value = !isPlain ? opponent[name] : '';

    return (
        <React.Fragment key={oppQuestion.id}>
            <FormGroup
                labelSize={'col-sm-3'}
                inputSize={'col-sm-6'}
                label={oppQuestion.name}
                variant={isPlain ? FORM_GROUP_VARIANTS.PLAIN : FORM_GROUP_VARIANTS.SELECT}
                inputProps={{
                    id: `question-id-${oppQuestion.id}`,
                    name: name,
                    label: label,
                    value: value,
                    onChange: evt => opponentHandler(evt.target.name, evt.target.value, opponentIndex),
                    options: isPlain ? [] : options,
                    required: oppQuestion.isRequired
                }}
                onLabelClick={ isLabelClickable ? () => openHistoryModal(oppQuestion, opponent.id) : undefined }
                formGroupTestId={`policy-application-${oppQuestion.machineName}`}
            />
            {oppQuestion.options.map(childQuestionOption =>
                childQuestionOption.id.toString() === opponent[name] && childQuestionOption.childQuestions.length > 0 
                ?
                    <React.Fragment key={childQuestionOption.id}>
                        {childQuestionOption.childQuestions.map(grandChildQuestion => {
                            const grandChildQuestionName = getInputName(grandChildQuestion.machineName);
                            const grandChildQuestionOptions = getOptions(grandChildQuestion, opponent[grandChildQuestionName]);
                            const grandChildQuestionSelectedOption = grandChildQuestionOptions.find(
                                o => o.key && opponent[grandChildQuestionName] && o.key.toString() === opponent[grandChildQuestionName].toString()
                            );
                            const grandChildQuestionLabel = isPlain && grandChildQuestionSelectedOption ? grandChildQuestionSelectedOption.label : '';
                            const grandChildQuestionValue = !isPlain ? opponent[grandChildQuestionName] : '';
                            const variant = isPlain ? FORM_GROUP_VARIANTS.PLAIN : FORM_GROUP_VARIANTS.SELECT;
                            // Calculate isLabelClickable for THIS specific grandchild question
                            const grandChildIsLabelClickable = checkIsLabelClickable(grandChildQuestion.machineName);
                            return (
                                <div key={grandChildQuestion.id}>
                                    <FormGroup
                                        labelSize={'col-sm-3'}
                                        inputSize={'col-sm-6'}
                                        label={grandChildQuestion.name}
                                        variant={variant}
                                        inputProps={{
                                            id: `question-id-${grandChildQuestion.id}`,
                                            name: grandChildQuestionName,
                                            label: grandChildQuestionLabel,
                                            value: grandChildQuestionValue,
                                            onChange: evt => opponentHandler(evt.target.name, evt.target.value, opponentIndex),
                                            required: !isPlain && grandChildQuestion.isRequired,
                                            options: isPlain ? [] : grandChildQuestionOptions
                                        }}
                                        onLabelClick={ grandChildIsLabelClickable ? () => openHistoryModal(grandChildQuestion, opponent.id) : undefined }
                                        formGroupTestId={`policy-application-${grandChildQuestion.machineName}`}
                                    />
                                    {grandChildQuestion.options.map(grandchildChildQuestionOption =>
                                        grandchildChildQuestionOption.id.toString() === opponent[name] && grandchildChildQuestionOption.childQuestions.length > 0 
                                        ?
                                            <React.Fragment key={grandchildChildQuestionOption.id}>
                                                {grandchildChildQuestionOption.childQuestions.map(
                                                    grandchildChildQuestion => {
                                                        const greatGrandChildQuestionName = getInputName(grandchildChildQuestion.machineName);
                                                        const otherInsurerAnswer = application?.applicationAnswersDtos?.find(({ id }) => id === opponent.otherInsurerId);
                                                        const greatGrandChildQuestionNameLabel = isPlain && otherInsurerAnswer ? otherInsurerAnswer.text : '';
                                                        const greatGrandChildQuestionValue = !isPlain ? opponent.otherInsurerName : '';
                                                        const variant = isPlain ? FORM_GROUP_VARIANTS.PLAIN : FORM_GROUP_VARIANTS.TEXT;
                                                        // Calculate isLabelClickable for THIS specific great-grandchild question
                                                        const greatGrandChildIsLabelClickable = checkIsLabelClickable(grandchildChildQuestion.machineName);
                                                        return (
                                                            <React.Fragment key={grandchildChildQuestion.id}>
                                                                <FormGroup
                                                                    labelSize={'col-sm-3'}
                                                                    inputSize={'col-sm-6'}
                                                                    label={grandchildChildQuestion.name}
                                                                    variant={variant}
                                                                    inputProps={{
                                                                        id: `question-id-${grandchildChildQuestion.id}`,
                                                                        name: greatGrandChildQuestionName,
                                                                        label: greatGrandChildQuestionNameLabel,
                                                                        value: greatGrandChildQuestionValue,
                                                                        onChange: evt => opponentHandler(evt.target.name, evt.target.value, opponentIndex),
                                                                        required: grandchildChildQuestion.isRequired,
                                                                        autoComplete: 'off'
                                                                    }}
                                                                    onLabelClick={ greatGrandChildIsLabelClickable ? () => openHistoryModal(grandchildChildQuestion, opponent.id) : undefined }
                                                                    formGroupTestId={`policy-application-${grandchildChildQuestion.machineName}`}
                                                                />
                                                            </React.Fragment>
                                                        );
                                                    }
                                                )}
                                            </React.Fragment>
                                        : 
                                            null
                                    )}
                                </div>
                            );
                        })}
                    </React.Fragment>
                :
                    null
            )}
        </React.Fragment>
    );
};

export default OpponentChildQuestion;